import { $fetch, $post, $put } from '@/services/axios';

export const CSV_URL = `company/campaigns/csv`;

export function add(data) {
  return $put(`company/campaign`, data);
}

export function fetch(data) {
  return $fetch(`company/campaigns`, data);
}

export function validate(data) {
  return $post(`company/campaign/validate`, data);
}

export function edit(data) {
  return $post(`company/campaign/${data.id}`, data);
}

export function one(data) {
  return $fetch(`company/campaign/get`, data);
}